import { FC } from 'react';
import { navigateToConnectors } from '../../../common/routing/app-navigator';
import ResolvedIssuesContainer from '../../../issues/resolved-issues/containers/ResolvedIssuesContainer';
import FixedPage from '../FixedPage';

const ResolvedIssuesPage: FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <FixedPage>
      <ResolvedIssuesContainer navigateToConnectors={navigateToConnectors} />
    </FixedPage>
  );
};

export default ResolvedIssuesPage;
